var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTripleDotsIcon = function SvgTripleDotsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 3,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M0 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M4.5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M10.5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
  })));
};
export { SvgTripleDotsIcon as ReactComponent };
export default __webpack_public_path__ + "29371ea6d6691cb2853bf56334c83b5a.svg";